import React from 'react';
import Submission from '../../components/submission';

export default function StepFinal() {
  return (
    <Submission/>
  );
}